import { formatNumber } from "../utils";

export const handleQuotations = (cotizacion) => {
  const base =
    `${cotizacion.moneda.simbolo} ` +
    formatNumber.new(cotizacion.primaBase ? cotizacion.primaBase : 0);

  const ahorro =
    `${cotizacion.moneda.simbolo} ` +
    formatNumber.new(cotizacion.primaAhorro ? cotizacion.primaAhorro : 0);

  const suma =
    `${cotizacion.moneda.simbolo} ` +
    formatNumber.new(cotizacion.sumaAsegurada ? cotizacion.sumaAsegurada : 0);

  const primaBase = {
    quote: "Prima base",
    data: cotizacion.primaBase ? base : "",
  };

  const primaAhorro = {
    quote: "Prima ahorro",
    data: cotizacion.primaAhorro ? ahorro : "",
  };

  const sumaAsegurada = {
    quote: "Suma asegurada",
    data: cotizacion.sumaAsegurada ? suma : "",
  };

  return {
    primaBase,
    primaAhorro,
    sumaAsegurada,
  };
};
